<template>

  <el-table
      :data="packages"
      style="width: 100%" border stripe
  >
    <slot name="user-column"></slot>
    <el-table-column :formatter="r => formatDateTime(r.created_at)" label="Создан" width="100"/>
    <el-table-column label="Месяц действия" prop="active_month" min-width="150"/>
    <el-table-column label="Подписи" min-width="150">
      <template #default="scope">
        <el-tag type="primary" v-for="n in scope.row.sender_names" style="margin-right: 5px;margin-bottom: 5px">
          {{n.sender_name}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="Оператор" :formatter="operGroup" min-width="150"/>
    <el-table-column label="Активность" min-width="150">
      <template #default="scope">
        <el-tag type="danger" v-if="scope.row.archived">Архив</el-tag>
        <el-tag type="success" v-else-if="!scope.row.archived && scope.row.active && scope.row.active_month === thisMonth">Да</el-tag>
        <el-tag type="warning" v-else-if="!scope.row.active && scope.row.delayed_activate_at && !scope.row.archived">С {{scope.row.delayed_activate_at}}</el-tag>
        <el-tag type="danger" v-else-if="(!scope.row.active || scope.row.active_month !== thisMonth) && !scope.row.archived">Нет</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="Автопродление" :formatter="autorepeat" min-width="150"/>
    <el-table-column label="Ёмкость" prop="capacity" min-width="130"/>
    <el-table-column label="Использовано" prop="used" min-width="130"/>
    <slot name="admin-actions"></slot>

  </el-table>


</template>


<script>

import RemoveButton from "@shared/components/layout/removeButton.component.vue";
import moment from "moment/moment";

export default {
  name: "PrepaidPackagesTable",
  components: {RemoveButton},
  props: ["packages"],
  watch: {
    systemId(){
      this.reload()
    }
  },
  methods: {
    reload(){

    },
    formatDateTime(val) {
      return moment(val).format("DD.MM.YYYY HH:mm:ss")
      // return moment(val).utcOffset(this.$store.getters.user.utcOffset || 0).format("DD.MM.YYYY HH:mm:ss")
    },
    activity(r){
      if(r.active) return "Да"
      if(r.delayed_activate_at) return `С ${r.delayed_activate_at}`
      return "Нет"
    },
    autorepeat(r){
      return r.to_be_repeated ? "Да" : "Нет"
    },
    operGroup(r){
      return this.$store.getters.operatorsGroups.find(g => String(g._id) === r.operator_id)?.title || "N/A"
    }
  },
  data(){
    return {
      thisMonth: moment().format("MM.YYYY"),
    }
  }
}

</script>

<style scoped>

</style>